import type { PartialTranslation } from "./index";

/** Vietnamese — see `../../vi/index.ts` for the terminology notes. */
export const nav: PartialTranslation["nav"] = {
  sections: {
    find: "Tìm",
    learn: "Học",
    "my-space": "Của tôi",
    community: "Cộng đồng",
  },
  items: {
    home: "Trang chủ",
    browse: "Khám phá",
    videos: "Video",
    "random-question": "Quay & Nói",
    "my-topics": "Chủ đề của tôi",
    vocabulary: "Từ vựng của tôi",
    collections: "Bộ sưu tập",
    notes: "Ghi chú",
    progress: "Tiến độ",
    "study-groups": "Nhóm học",
    "ai-chat": "Trò chuyện AI",
    leaderboard: "Bảng xếp hạng",
  },
  groups: {
    myTopics: "Chủ đề & luyện tập",
    vocabulary: "Từ vựng",
    community: "Cộng đồng",
  },
  actions: {
    expand: "Mở rộng {{name}}",
    collapse: "Thu gọn {{name}}",
    expandSidebar: "Mở rộng thanh điều hướng",
    collapseSidebar: "Thu gọn thanh điều hướng",
  },
  header: {
    search: "Tìm chủ đề",
    searchPlaceholder: "Tìm chủ đề...",
    menu: "Mở menu",
    home: "Trang chủ",
  },
  search: {
    trigger: "Tìm kiếm",
    open: "Tìm chủ đề và cách phát âm",
    topicsRow: "Tìm chủ đề",
    topicsAria: "Tìm chủ đề",
    topicsTitle: "Tìm chủ đề",
    topicsDescription: "Tìm một chủ đề để luyện tập theo tiêu đề hoặc danh mục.",
    pronunciationRow: "Phát âm",
    pronunciationAria: "Tìm cách phát âm của một từ trong video",
    pronunciationTitle: "Phát âm",
    pronunciationDescription: "Nghe một từ được người thật nói trong thư viện video.",
    topicsPlaceholder: "Tìm chủ đề...",
    pronunciationPlaceholder: "Tìm một từ trong lời nói thật...",
    topicsHint: "Tìm chủ đề theo tiêu đề hoặc danh mục.",
    topicsHintSecondary: "Mỗi kết quả mở ra một bài học thật để bạn luyện tập.",
    topicsNoResultsHint:
      "Chủ đề được khớp theo tiêu đề — hãy thử một từ ngắn hơn, hoặc mở Khám phá để lọc theo danh mục.",
    pronunciationHint: "Nghe một từ được nói trong video thật.",
    pronunciationHintSecondary:
      "Gõ một từ, rồi phát đúng khoảnh khắc ai đó nói nó — giảm tốc độ và nhại lại theo câu đó.",
    tryExamples: "Thử",
    moments: "Khoảnh khắc",
    tooShort: "Nhập ít nhất {{count}} ký tự.",
    topicsError: "Không tìm được chủ đề lúc này.",
    pronunciationError: "Không tìm được thư viện video lúc này.",
    topicsEmpty: "Không có chủ đề nào khớp “{{query}}”.",
    pronunciationEmpty: "Chưa có video nào nói “{{query}}”.",
    footerIdle: "Nhập để tìm kiếm",
    seeAllTopics: "Xem tất cả {{count}} kết quả cho “{{query}}”",
    searchAllTopics: "Tìm tất cả chủ đề cho “{{query}}”",
    hearInVideos: "Nghe trong {{count}} video",
    searchPronunciation: "Tìm trong video: “{{query}}”",
  },
  avatar: {
    profile: "Hồ sơ",
    openProfile: "Mở cài đặt hồ sơ",
    myTopics: "Chủ đề của tôi",
    myVocabulary: "Từ vựng của tôi",
    takeTour: "Xem hướng dẫn",
    signOut: "Đăng xuất",
    signedOutTitle: "Đã đăng xuất",
    signedOutDescription: "Bạn đã đăng xuất thành công.",
    /** Nhãn nhóm ngôn ngữ + giao diện ở cuối menu hồ sơ. */
    device: "Thiết bị này",
    streak: {
      idle: "Bắt đầu chuỗi hôm nay",
      active: "Chuỗi {{count}} ngày",
      dayWord: "ngày",
      openActive: "Chuỗi {{count}} ngày — xem chi tiết chuỗi",
      openIdle: "Chưa có chuỗi nào — xem chi tiết chuỗi",
    },
    level: "Cấp {{level}}",
    levelProgress: "Tiến độ lên cấp tiếp theo",
    xp: "{{count}} XP",
    theme: {
      label: "Giao diện",
      light: "Sáng",
      dark: "Tối",
      system: "Hệ thống",
      lightAria: "Giao diện sáng",
      darkAria: "Giao diện tối",
      systemAria: "Giao diện hệ thống",
    },
  },
  mobile: {
    more: "Thêm",
    tabBar: "Điều hướng chính",
  },
  /** Landing-page header links (apps/www shell is separate). */
  landing: {
    about: "Giới thiệu",
    updates: "Cập nhật",
  },
  breadcrumbHome: "Trang chủ",
  };
